import React, { useEffect, useState } from "react";
import {
  DateInput,
  SelectInput,
  TextInput,
} from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import CommonModal from "../../components/common/ui/NotificationModal/CommonModal";
import Table from "../../components/common/table/Table";
import { useDispatch, useSelector } from "react-redux";
import { logReportAction, masterActions } from "../../_store";
import {
  fDate,
  formatDateTimeAMPM,
  MinDate,
  Today,
} from "../../utils/formatTime";
import activeIcon from "../../assets/svg/active-user.svg";
import inactiveIcon from "../../assets/svg/inactive-user.svg";
import generateXlsx from "../../components/common/export/generateXlsx";
import { Popup } from "../../components/common/ui/NotificationModal/Popup";
import CustomLoader from "../../components/common/ui/Loader";

function KIOSKAccessInmateReport() {
  const {
    facilityDropDown,
    logHistorFirstName,
    logHistoryLastName,
    GetPodList,
  } = useSelector((x) => x.master);

  const {
    KioskAccessReport,
    KioskAccessGridList,
    KioskAccessGridFullList,
    kioskAccessDetails,
  } = useSelector((x) => x.logReport);

  const { podStatusOptions } = useSelector((x) => x.dropdownOptions);

  let KioskAccessReportSearch = { ...KioskAccessReport };
  const [showSearchFields, setShowSearchFields] = useState(false);

  const dispatch = useDispatch();

  //Excel
  useEffect(() => {
    if (KioskAccessGridFullList?.DataList?.length > 0) {
      const title = "AnyKioskAccessInmateReport";
      const generateColumn = [
        "Inmate ID",
        "Inmate Name",
        "Facility Code",
        "Own POD",
        "Accessed POD Count",
        "No of Attempt",
        "Last Login On",
        "Status",
      ];
      const exportExcelData = KioskAccessGridFullList?.DataList?.map((obj) => ({
        InmateID: obj.InmateResidentId,
        InmateFullName: obj.InmateFullName,
        FacilityCode: obj.FacilityCode,
        OwnPodCode: obj.OwnPodCode,
        AccessedSharedPodCount: obj.PodAccessedCount,
        LoginCount: obj.LoginCount,
        LastLoginDate: formatDateTimeAMPM(obj.LastLoginDate),
        InmateStatus: obj.InmateStatus,
      }));

      // Generate the Excel file with the transformed data

      try {
        generateXlsx(exportExcelData, generateColumn, title);
        dispatch(logReportAction.clearKioskFullList());
      } catch (error) { }
    }
  }, [KioskAccessGridFullList]);

  const handleExcel = () => {
    let updatedParams = {
      ...KioskAccessReportSearch,
      PageNo: 1,
      RowCountPerPage: KioskAccessGridList?.TotalRecordCount,
      exportExcel: true,
    };

    dispatch(logReportAction.AnyKioskAccessInmateReport(updatedParams));
  };

  //Load Facility dropdown List
  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({ facilityID: 0, activeStatus: 1 })
    );
  }, [dispatch]);
  useEffect(() => {
    handleReset();
  }, []);

  const handleSelectChange = (selectedOption, name) => {
    const loadGridList = () => {
      dispatch(
        logReportAction.AnyKioskAccessInmateReport({
          ...KioskAccessReportSearch,
          PageNo: 1,
        })
      );
      dispatch(
        logReportAction.setkioskAccess({
          ...KioskAccessReportSearch,
          PageNo: 1,
          RowCountPerPage: 10,
        })
      );
    };

    const handleFacilityID = () => {
      KioskAccessReportSearch.FirstNameValue = 0;
      KioskAccessReportSearch.FirstName = "";
      KioskAccessReportSearch.LastNameValue = 0;
      KioskAccessReportSearch.LastName = "";
      KioskAccessReportSearch.PodID = 0;
      KioskAccessReportSearch[name] = selectedOption?.value || 0;

      dispatch(
        masterActions.GetInmateFirstName({
          facilityID: KioskAccessReportSearch[name],
          LastName: KioskAccessReportSearch?.LastName,
        })
      );
      dispatch(
        masterActions.GetInmateLastName({
          facilityID: KioskAccessReportSearch[name],
          firstName: KioskAccessReportSearch?.FirstName,
        })
      );
      dispatch(masterActions.GetPODList(KioskAccessReportSearch[name]));

      loadGridList();
    };

    const handlePod = () => {
      if (selectedOption?.value == null) {
        // This checks for both null and undefined
        KioskAccessReportSearch[name] = 0; // Clear the value
        loadGridList(); // Reload the data
      } else {
        KioskAccessReportSearch[name] = selectedOption?.value;
        loadGridList();
      }
    };

    const handleFirstName = () => {
      KioskAccessReportSearch[name] = selectedOption
        ? selectedOption?.value > 0
          ? selectedOption?.label
          : ""
        : "";

      KioskAccessReportSearch.FirstNameValue = selectedOption?.value || 0;

      dispatch(
        masterActions.GetInmateLastName({
          facilityID: KioskAccessReportSearch.FacilityID,
          firstName: KioskAccessReportSearch.FirstName,
        })
      );

      loadGridList();
    };

    const handleLastName = () => {
      KioskAccessReportSearch[name] = selectedOption
        ? selectedOption?.value > 0
          ? selectedOption?.label
          : ""
        : "";

      KioskAccessReportSearch.LastNameValue = selectedOption?.value || 0;

      //Need clear the FiestName when i choose the Lastname
      KioskAccessReportSearch.FirstName = "";
      KioskAccessReportSearch.FirstNameValue = 0;

      dispatch(
        masterActions.GetInmateFirstName({
          facilityID: KioskAccessReportSearch?.FacilityID,
          LastName: KioskAccessReportSearch?.LastName,
        })
      );

      loadGridList();
    };

    switch (name) {
      case "FacilityID":
        handleFacilityID();
        break;

      case "PodID":
        handlePod();
        break;

      case "FirstName":
        handleFirstName();
        break;

      case "LastName":
        handleLastName();
        break;

      case "AnyKioskInmateStatus":
        KioskAccessReportSearch[name] =
          selectedOption?.value === 0 ? 0 : selectedOption?.value || 1;
        loadGridList();
        break;

      default:
        console.warn(`Unhandled field name: ${name}`);
    }

    //dispatch(logReportAction.setkioskAccess(KioskAccessReportSearch));
  };

  const handleChange = (e) => {
    const { value, name } = e.target;

    KioskAccessReportSearch.InmateResidentID = value.replace(/\D/g, "");

    dispatch(logReportAction.setkioskAccess(KioskAccessReportSearch));
  };

  const handleDateChange = (value, name) => {
    const date = fDate(value);
    KioskAccessReportSearch[name] = date;
    dispatch(logReportAction.setkioskAccess(KioskAccessReportSearch));
  };

  const handleDateBlur = (e, fieldName) => {
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;

    if (fieldName === "FromDate") {
      if (
        KioskAccessReportSearch.ToDate &&
        new Date(value) > new Date(KioskAccessReportSearch.ToDate)
      ) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (fieldName === "ToDate") {
      if (
        KioskAccessReportSearch.FromDate &&
        new Date(value) < new Date(KioskAccessReportSearch.FromDate)
      ) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = MinDate();
    const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...KioskAccessReportSearch,
      FromDate:
        fieldName === "FromDate"
          ? isFromValid && isValidDate
            ? value
            : ""
          : KioskAccessReportSearch.FromDate, // preserve existing value
      ToDate:
        fieldName === "ToDate"
          ? isToValid && isValidDate
            ? value
            : ""
          : KioskAccessReportSearch.ToDate, // preserve existing value
    };
    dispatch(logReportAction.setkioskAccess(updatedParam));
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (!KioskAccessReportSearch.FacilityID) {
      dispatch(logReportAction.clearinmateAccessReportList());
      Popup({
        title: "Message",
        text: `Select any one of the Facility Code in the dropdown list`,
        icon: "info",
        confirmButtonText: "Ok",
      });
    }

    dispatch(
      logReportAction.AnyKioskAccessInmateReport({
        ...KioskAccessReportSearch,
        PageNo: 1,
        RowCountPerPage: 10,
      })
    );
    dispatch(
      logReportAction.setkioskAccess({
        ...KioskAccessReportSearch,
        PageNo: 1,
        RowCountPerPage: 10,
      })
    );
  };

  const handleReset = () => {
    dispatch(logReportAction.resetKioskAccess());
  };

  //Table

  const column = [
    {
      name: "Inmate ID",
      key: "InmateResidentId",
      selector: (row) => row.InmateResidentId,
      sortable: true,
    },
    {
      name: "Inmate Name",
      key: "InmateFullName",
      selector: (row) => row.InmateFullName,
      sortable: true,
    },
    {
      name: "Facility Code",
      key: "FacilityCode",
      selector: (row) => row.FacilityCode,
      sortable: true,
    },
    {
      name: "Own POD",
      key: "OwnPodCode",
      selector: (row) => row.OwnPodCode,
      sortable: true,
    },
    {
      name: "Accessed POD Count",
      key: "PodAccessedCount",
      selector: (row) => row.PodAccessedCount,
      sortable: true,
    },
    {
      name: "No of Attempt",
      key: "LoginCount",
      selector: (row) => formatDateTimeAMPM(row.LastLoginDate),
      cell: (row) => (
        <div
          className="Common_Link_Style"
          data-bs-toggle="modal"
          data-bs-target="#Kiosk_Access"
          onClick={() => handlePopupGrid(row)}
        >
          {row.LoginCount}
        </div>
      ),
      sortable: true,
    },
    {
      name: "Last Login On",
      key: "LastLoginDate",
      selector: (row) => formatDateTimeAMPM(row.LastLoginDate),
      sortable: true,
    },
    {
      name: "Status",
      key: "InmateStatus",
      selector: (row) => row.InmateStatus,
      cell: (row) => (
        <div className="d-flex flex-wrap justify-content-center align-items-center h-100">
          <img
            title={row.InmateStatus}
            src={row.InmateStatus === "Active" ? activeIcon : inactiveIcon}
            alt={row.InmateStatus === 1 ? "Active User" : "Inactive User"}
            style={{ width: "20px", height: "20px" }} // Adjust icon size as needed inactiveIcon
          />
        </div>
      ),
      sortable: true,
      center: true,
    },
  ];

  const kioskAccessDetilsColumn = [
    {
      name: "POD",
      key: "PODCode",
      selector: (row) => row.PodCode,
      sortable: true,
    },
    {
      name: "Kiosk Code",
      key: "KioskCode",
      selector: (row) => row.KioskCode,
      sortable: true,
    },
    {
      name: "Login On",
      key: "LogInDate",
      selector: (row) => formatDateTimeAMPM(row.LogInDate),
      sortable: true,
    },
    {
      name: "Any Kiosk Access",
      key: "CurrentAnyKioskAccessStatus",
      selector: (row) => row.CurrentAnyKioskAccessStatus,
      cell: (row) => (
        <div className="d-flex flex-wrap justify-content-center align-items-center h-100">
          <img
            title={row.CurrentAnyKioskAccessStatus}
            src={
              row.CurrentAnyKioskAccessStatus === "Allowed"
                ? activeIcon
                : inactiveIcon
            }
            alt={
              row.CurrentAnyKioskAccessStatus === 1 ? "Allowed" : "Not Allowed"
            }
            style={{ width: "20px", height: "20px" }} // Adjust icon size as needed inactiveIcon
          />
        </div>
      ),
      sortable: true,
      center: true,
    },
  ];

  //Popup Grid
  const [kioskReportDetails, setKioskReportDetails] = useState({
    FacilityID: 0,
    InmateId: 0,
    FromDate: "",
    ToDate: "",
    PageNo: 1,
    RowCountPerPage: 10,
    SortField: "",
  });

  const handlePopupGrid = (row) => {
    // Create a parameter object based on podAccessDetails

    let param = { ...kioskReportDetails };
    param.FacilityID = row.facilityID;
    param.InmateId = row.InmateID;
    param.FromDate = KioskAccessReportSearch.FromDate;
    param.ToDate = KioskAccessReportSearch.ToDate; // Corrected assignment for ToDate
    param.RowCountPerPage = 10;
    param.PageNo = 1;
    // Update state with the new parameter object
    setKioskReportDetails(param);

    dispatch(logReportAction.AnyKioskAccessInmateReportDetails(param));
  };

  //Pagination

  useEffect(() => {
    dispatch(
      logReportAction.AnyKioskAccessInmateReport(KioskAccessReportSearch)
    );
  }, [KioskAccessReportSearch.PageNo, KioskAccessReportSearch.RowCountPerPage]);

  useEffect(() => {
    dispatch(
      logReportAction.AnyKioskAccessInmateReportDetails(kioskReportDetails)
    );
  }, [kioskReportDetails.PageNo, kioskReportDetails.RowCountPerPage]);

  //Sorting
  let isSorting = false; // to restrict the pagination issue
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    // setSorting(true);
    isSorting = true;
    const search = { ...KioskAccessReport };
    const newSortOrder = search.SortField.includes(column.key)
      ? search.SortField.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";

    search.SortField = `${column.key} ${newSortOrder}`;
    dispatch(logReportAction.setkioskAccess(search));
    dispatch(
      logReportAction.AnyKioskAccessInmateReport({
        ...KioskAccessReport,
        SortField: `${column.key} ${newSortOrder}`,
      })
    );
  };

  let isModalSorting = false; // to restrict the pagination issue
  const handleSortModal = (column, sortDirection) => {
    if (!column?.key) return;
    isModalSorting = true;
    const search = { ...kioskReportDetails };
    const newSortOrder = search.SortField.includes(column.key)
      ? search.SortField.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";

    search.SortField = `${column.key} ${newSortOrder}`;
    setKioskReportDetails(search);

    dispatch(
      logReportAction.AnyKioskAccessInmateReportDetails({
        ...kioskReportDetails,
        SortField: `${column.key} ${newSortOrder}`,
      })
    );
  };

  const handlePageChange = (value, name) => {
    if (name === "AnyKioskAccessGrid") {
      if (isSorting) {
        isSorting = false;
        return;
      }
      KioskAccessReportSearch.PageNo = value;
      dispatch(logReportAction.setkioskAccess(KioskAccessReportSearch));
    } else if (name === "PopupTable") {
      if (isModalSorting) {
        isModalSorting = false;
        return;
      }
      setKioskReportDetails((prev) => ({
        ...prev,
        PageNo: value,
      }));
    }
  };

  // const handleRowPerPage = (value, name) => {
  //   if (name === "AnyKioskAccessGrid") {
  //     KioskAccessReportSearch.RowCountPerPage = value;
  //     dispatch(logReportAction.setkioskAccess(KioskAccessReportSearch));
  //   } else if (name === "PopupTable") {
  //     setKioskReportDetails((prev) => ({
  //       ...prev,
  //       RowCountPerPage: value,
  //     }));
  //   }
  // };

  // Call API when page changes

  const handleRowPerPage = (value, name) => {
    if (name === "AnyKioskAccessGrid") {
      const params = {
        ...KioskAccessReportSearch,
        RowCountPerPage: value,
        PageNo: 1,
      };
      dispatch(logReportAction.setkioskAccess(params));
    } else if (name === "PopupTable") {
      setKioskReportDetails((prev) => ({
        ...prev,
        RowCountPerPage: value,
        PageNo: 1,
      }));
    }
  };

  if (KioskAccessGridList?.loading) {
    return <CustomLoader />;
  }
  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };
  const renderSearch = () => {
    return (
      <form>
        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="facilityID"
                label="Facility Code"
                options={facilityDropDown}
                value={KioskAccessReportSearch?.FacilityID}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "FacilityID")
                }
                isMulti={false}
                isClearable={KioskAccessReportSearch?.FacilityID ? true : false}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="InmateResidentID"
                id="InmateResidentID"
                label="Inmate ID"
                value={KioskAccessReportSearch?.InmateResidentID}
                handleChange={handleChange}
                placeholder=""
                disabled={false}
                maxLength={18}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="LastName"
                label="Last Name"
                options={logHistoryLastName}
                value={KioskAccessReportSearch?.LastNameValue}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "LastName")
                }
                isMulti={false}
                isClearable={
                  KioskAccessReportSearch?.LastNameValue ? true : false
                }
                isDisabled={!KioskAccessReportSearch.FacilityID}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="FirstName"
                label="First Name"
                options={logHistorFirstName}
                value={KioskAccessReportSearch?.FirstNameValue}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "FirstName")
                }
                isMulti={false}
                isClearable={
                  KioskAccessReportSearch?.FirstNameValue ? true : false
                }
                isDisabled={!KioskAccessReportSearch.FacilityID}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="PodID"
                label="POD"
                options={GetPodList}
                value={KioskAccessReportSearch?.PodID}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "PodID")
                }
                isMulti={false}
                isClearable={KioskAccessReportSearch?.PodID ? true : false}
                isDisabled={!KioskAccessReportSearch.FacilityID}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="AnyKioskInmateStatus"
                label="Inmate Status"
                options={podStatusOptions}
                value={KioskAccessReportSearch?.AnyKioskInmateStatus}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "AnyKioskInmateStatus")
                }
                // isDisabled={KioskAccessReportSearch.FacilityID === 0 ? true : false}
                isMulti={false}
                isClearable={
                  KioskAccessReportSearch?.AnyKioskInmateStatus !== 1
                }
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <DateInput
              name="FromDate"
              label="From Date"
              maxDate={
                KioskAccessReportSearch?.ToDate
                  ? KioskAccessReportSearch?.ToDate
                  : new Date()
              }
              minDate={new Date(2017, 0, 1)}
              value={KioskAccessReportSearch?.FromDate || null}
              handleChange={(date) => handleDateChange(date, "FromDate")}
              yearDropDown={true}
              // required
              isClearable={true}
              // errorMessage={errorMessage}
              handleBlur={(e) => handleDateBlur(e, "FromDate")}
            />
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <DateInput
              name="ToDate"
              label="To Date"
              minDate={
                KioskAccessReportSearch?.FromDate || new Date(2017, 0, 1)
              }
              maxDate={new Date()}
              value={KioskAccessReportSearch?.ToDate || null}
              handleChange={(date) => handleDateChange(date, "ToDate")}
              // required
              isClearable={true}
              // errorMessage={errorMessage}
              handleBlur={(e) => handleDateBlur(e, "ToDate")}
            />
          </div>
        </div>

        <div className="mt-3 d-flex flex-wrap justify-content-center gap-3 flex-wrap">
          <Button
            className="me-2"
            label="Search"
            type="submit"
            status="primary"
            icon={"search"}
            onClick={handleSearch}
          />
          <Button
            className="me-2"
            label="Reset"
            type="button"
            icon={"fa-solid fa-rotate-right"}
            status="secondary"
            onClick={handleReset}
          />
        </div>
      </form>
    );
  };

  return (
    <div>
      <div className="card b-r-all  p-4 border border-dark-grey mt-3 me-3 w-100">
        {/* <div className="mb-2">
          <h2 className="form_title_uppercase text-color">
            Any Kiosk Access Search
          </h2>
        </div> */}
        <div className=" d-block d-md-none">
          <div
            className=" d-flex align-items-center justify-content-between"
            style={{ background: "transparent", cursor: "pointer" }}
            onClick={toggleInformation}
          >
            <h2 className="form_title_uppercase text-color">
              Any Kiosk Access Inmate Report Search
            </h2>
            <i
              id="itagInformation"
              className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""}`}
              style={{ fontSize: "20px" }}
            ></i>
          </div>
        </div>
        {/* Mobile only (Below md breakpoint) */}
        <div className="d-block d-md-none mt-2">
          {showSearchFields && renderSearch()}
        </div>

        {/* Web only (Desktop and above) */}
        <div className="mb-3 d-none d-md-block">
          <h2 className="form_title_uppercase text-color">
            Any Kiosk Access Inmate Report Search
          </h2>
        </div>
        {/* Web only (Desktop and above) */}
        <div className="d-none d-md-block">{renderSearch()}</div>
      </div>

      <div className="mt-5">
        {KioskAccessReportSearch.FacilityID == 0 ? (
          <div className="text-center">
            <b className="table-no-data-text mt-5 fs-4 mb-5">
              Select any one of the Facility Code in the dropdown list
            </b>
          </div>
        ) : (
          <>
            {KioskAccessGridList?.DataList?.length > 0 && (
              <>
                <div className=" d-flex gap-3 align-items-center mb-2 ">
                  <div className="col-12 d-flex flex-wrap justify-content-between align-items-center resp-space">
                    <h2 className="form_title_uppercase text-color">
                      Any Kiosk Access Inmate Report LIST
                    </h2>

                    {/* Right-aligned Export Button */}
                    <div>
                      <ExcelExport handleExcelExport={handleExcel} />
                    </div>
                  </div>
                </div>
                {/* Left-aligned Content */}
                <div className="d-flex flex-wrap align-items-center gap-3 mt-2 mb-2">
                  <div className="d-flex flex-wrap align-items-center">
                    <img
                      src={activeIcon}
                      alt="Active Icon"
                      style={{ width: "20px", height: "20px" }}
                    />
                    <span className="ms-2">Inmate Current</span>
                  </div>
                  <div className="d-flex flex-wrap align-items-center">
                    <img
                      src={inactiveIcon}
                      alt="Inactive Icon"
                      style={{ width: "20px", height: "20px" }}
                    />
                    <span className="ms-2">Inmate Released</span>
                  </div>
                </div>
              </>
            )}

            {/* Table */}
            <Table
              columns={column}
              data={KioskAccessGridList?.DataList}
              pagination={true}
              onChangePage={(e) => handlePageChange(e, "AnyKioskAccessGrid")} // Call API when page changes
              onChangeRowsPerPage={(e) =>
                handleRowPerPage(e, "AnyKioskAccessGrid")
              }
              totalRowCount={KioskAccessGridList?.TotalRecordCount}
              currentPage={KioskAccessReportSearch?.PageNo}
              paginationPerPage={KioskAccessReportSearch?.RowCountPerPage}
              serverSideSort
              onSort={handleSort}
              sortColumn={KioskAccessReportSearch?.SortField?.split(" ")[0]}
              sortDirection={KioskAccessReportSearch?.SortField?.split(" ")[1]}
            />
          </>
        )}

        <CommonModal
          modalId="Kiosk_Access"
          title="DETAILS OF ANY KIOSK ACCESS"
          loader={kioskAccessDetails?.loading}
          bodyContent={
            <>
              <div className="d-flex flex-wrap align-items-center gap-3 mb-2">
                <div className="d-flex flex-wrap align-items-center">
                  <img
                    src={activeIcon}
                    alt="Active Icon"
                    style={{ width: "20px", height: "20px" }}
                  />
                  <span className="ms-2">Allowed</span>
                </div>
                <div className="d-flex flex-wrap align-items-center">
                  <img
                    src={inactiveIcon}
                    alt="Inactive Icon"
                    style={{ width: "20px", height: "20px" }}
                  />
                  <span className="ms-2">Not Allowed</span>
                </div>
              </div>
              <Table
                title={""}
                columns={kioskAccessDetilsColumn}
                data={kioskAccessDetails?.DataList || []} // Fallback to an empty array
                pagination={true}
                onChangePage={(e) => handlePageChange(e, "PopupTable")} // Call API when page changes
                onChangeRowsPerPage={(e) => handleRowPerPage(e, "PopupTable")} // Handle rows per page  change
                totalRowCount={kioskAccessDetails?.TotalRecordCount}
                currentPage={kioskReportDetails?.PageNo}
                paginationPerPage={kioskReportDetails?.RowCountPerPage}
                serverSideSort
                onSort={handleSortModal}
                sortColumn={kioskReportDetails?.SortField?.split(" ")[0]}
                sortDirection={kioskReportDetails?.SortField?.split(" ")[1]}
              />
            </>
          }
          footerContent={
            <button
              className="btn button-primary"
              data-bs-dismiss="modal"
            // onClick={handleCloseModal}
            >
              Close
            </button>
          }
        />
      </div>
    </div>
  );
}

export default React.memo(KIOSKAccessInmateReport);
